var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4 7.2H20M10.4 11.2V15.2M13.6 11.2V15.2M5.6 7.2H18.4L17.136 18.576C17.0927 18.9675 16.9065 19.3293 16.613 19.592C16.3196 19.8548 15.9395 20 15.5456 20H8.4544C8.06051 20 7.68045 19.8548 7.387 19.592C7.09355 19.3293 6.90733 18.9675 6.864 18.576L5.6 7.2ZM8.276 4.9176C8.4054 4.64317 8.61017 4.4112 8.8664 4.24873C9.12264 4.08626 9.4198 4 9.7232 4H14.2768C14.5803 3.99984 14.8777 4.08604 15.1341 4.24851C15.3905 4.41099 15.5953 4.64305 15.7248 4.9176L16.8 7.2H7.2L8.276 4.9176V4.9176Z",
    stroke: "#D01818",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.067c92b36372614a8a8f7b1700f0cf45.svg";
export { ForwardRef as ReactComponent };